import React from "react";
import { Box, Typography } from "@mui/material";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import { useTranslation } from "react-i18next";

interface NoDataProps {
  message?: string;
}

const NoDataFound: React.FC<NoDataProps> = ({ message  }) => {

  const {t} = useTranslation();
  
  message = t("No_Data_Found")

  return (
    <Box
      sx={{
        textAlign: "center",
        padding: "40px 0",
        color: "#888",
      }}
    >
      <SentimentDissatisfiedIcon sx={{ fontSize: 50, color: "#bbb" }} />
      <Typography variant="h3" mt={1}>
        {message}
      </Typography>
    </Box>
  );
};

export default NoDataFound;

  